






































import { Vue, Component, Provide, Watch } from 'vue-property-decorator';
import Header from './component/header';
import Avatar from '../../component-dev/avatar';
import { activity } from '../../service/activity';
import { IS_ANDROID, IS_MQQ, IS_ZXG } from '../../service/platform/environment';
import qs from 'qs';
import { makeStatReportParam } from '../../service/stat/Directive';
import { stat } from '../../service/stat';
// action=8 返回领取的凭条
// act_type = 10000：微证券;
// act_type = 10001：自选股;


@Component({
  components: {
    Header,
    Avatar,
  }
})




export default class Page extends Vue {
  money: string;
  isHasGet: boolean = false;
  $dialog: any;
  rewardInfo: any = {
    reward_value: "--",
    state: "--",
    act_type: "--",
  };
  isGet: boolean = false;
  headimgurl: string = '--';
  userInfo: any;
  actType: any = {
    10000: '微证券',
    10001: '自选股',
  };

  showRedbag: boolean = false; //cgi正常返回后显示红包

  errorTips: string = '';

	get isZxg() {
		const query = qs.parse(location.search.substring(1));
		return IS_MQQ ||
			IS_ZXG ||
			this.$route.query.from === 'zxg' ||
			query.from === 'zxg' || query._from === 'zxg' || this.$route.query._from === 'zxg';
	}
  
  props: {
    avatarUrl: String,
  }
  
  created () {
    
  }

  async beforeMount() {
  }
  
  async mounted() {
    this.headimgurl = localStorage.getItem('headimgurl');
    //如果本地存储没有头像信息，则通过userInfo接口获取
    if (this.headimgurl == '') {
        const { data: userInfo } = await activity.getUserInfo();
        this.headimgurl = userInfo.headimgurl;
    }
    this.init();
  }
  
async beforegetReward() {
  let self = this;
  try {
    const { data } = await activity.beforeGetReward();
    self.rewardInfo = data;
    if (self.rewardInfo.reward_value) {
      self.isGet = true;
    }
    // self.rewardInfo.reward_value = data.reward_value / 100;
    // 如果用户未领奖，就去调用领奖接口
    if (self.rewardInfo.state !== '2') {
      self.getReward();
    }
  } catch (e) {
    const { data = {} } = e;
    this.$dialog.alert({ 
      content: '系统繁忙，请稍后重试', 
      confirmBtn: '确定',
    });
  }
}

  async getReward() {
    try {
      const { data } = await activity.getReward();
      this.rewardInfo = data;
      this.showRedbag = true;      
    } catch (e) {        
      const { data = {} } = e; 
      this.$dialog.alert({
        content: data.retmsg,
        confirmBtn: '确定',
      });
      this.errorTips = '开市大吉';
    }
  }

  shakeLabel() {
    const currentPath = this.$route.path;
    if (IS_ZXG) {
        stat.sendClickStat(
            makeStatReportParam('19newyear.label.getlabel.click.zxg', currentPath),
            currentPath,
        );
    } else {
        stat.sendClickStat(
            makeStatReportParam('19newyear.label.getlabel.click', currentPath),
            currentPath,
        );
    }
    setTimeout(() => {
      this.$router.replace('/label');
		// this.$router.push({path: '/label', query: {}, replace: true});
    }, 1000);
  }
  
  init() {
    this.beforegetReward();
  }
}
